<template>
  <div>
    <b-form @submit="onSubmit" @reset="onReset" @close="onClose" v-if="show">
      
      <b-alert v-if="isEditingExisting" show variant="warning" class="mt-2">
        <strong>CẢNH BÁO:</strong> PN 10 này đã tồn tại trong Kho Tuấn. Bạn đang <strong>SỬA</strong> record cũ. 
        <br>Thông tin cũ: Tồn kho hiện tại là {{ existingTonKho }}
      </b-alert>

      <b-form-group id="input-group-1" label="Pn 10:" label-for="pn-10">
        <b-form-input
          id="pn-10"
          type="text"
          v-model="form.pn_10"
          v-on:input="pn_10_listener"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Stamping:" label-for="stamping">
        <b-form-input id="stamping" v-model="form.stamping" type="text"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-3" label="English Description:" label-for="english_des">
        <b-form-input id="english_des" v-model="form.english_des" type="text"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-4" label="Import Description (Tên nhập khẩu):" label-for="import_des">
        <b-form-input id="import_des" v-model="form.import_des" type="text"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-6" label="Số lượng nhập:" label-for="so_luong_nhap">
        <b-form-input
          id="so-luong-nhap"
          v-model="form.so_luong_nhap"
          type="text"
          v-on:input="update_ton_kho_hien_tai"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-7" label="Số lượng xuất:" label-for="so_luong_xuat">
        <b-form-input
          id="so-luong-xuat"
          v-model="form.so_luong_xuat"
          type="text"
          v-on:input="update_ton_kho_hien_tai"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-5" label-for="ton-kho-hien-tai">
        <template #label>
          Tồn kho hiện tại (Kho Tuấn): 
          <span v-if="form.so_luong_nhap || form.so_luong_xuat" :class="form.ton_kho_hien_tai < 0 ? 'text-danger font-weight-bold' : 'text-primary small'">
            ({{ ton_kho_hien_tai_temp }} + {{ form.so_luong_nhap || 0 }} - {{ form.so_luong_xuat || 0 }} = {{ form.ton_kho_hien_tai }})
            <span v-if="form.ton_kho_hien_tai < 0"> [CẢNH BÁO: ÂM KHO]</span>
          </span>
        </template>
        <b-form-input
          id="ton-kho-hien-tai"
          v-model="form.ton_kho_hien_tai"
          type="text"
          :state="form.ton_kho_hien_tai < 0 ? false : null"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-8" label-for="ton-kho-khac">
        <template #label>Tồn Kho TLT:</template>
        <b-form-input
          readonly
          id="ton-kho-khac"
          v-model="form.ton_kho_khac"
          type="text"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-9" label-for="tong_ton_kho">
        <template #label>
          Tổng tồn kho: 
          <span :class="form.tong_ton_kho < 0 ? 'text-danger font-weight-bold' : 'text-success small'">
            ({{ form.ton_kho_hien_tai || 0 }} + {{ form.ton_kho_khac || 0 }} = {{ form.tong_ton_kho }})
          </span>
          <span v-if="isLoaded && isNotMatch" class="text-danger font-weight-bold ml-2">⚠️ KHÔNG KHỚP KHO CHÍNH</span>
        </template>
        <b-form-input
          readonly
          id="tong_ton_kho"
          v-model="form.tong_ton_kho"
          type="text"
          :state="(isLoaded && isNotMatch) ? false : (form.tong_ton_kho < 0 ? false : null)"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-10" label-for="ton_cuoi_kho_chinh">
        <template #label>
          Tồn cuối kho chính:
          <span v-if="isLoaded && isNotMatch" class="text-danger font-weight-bold ml-2">⚠️ SAI LỆCH VỚI TỔNG TỒN</span>
        </template>
        <b-form-input
          readonly
          id="ton_cuoi_kho_chinh"
          v-model="form.ton_cuoi_kho_chinh"
          type="text"
          :state="(isLoaded && isNotMatch) ? false : null"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-11" label="Vị trí:" label-for="location">
        <b-form-input id="location" v-model="form.location" type="text"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-12" label="Giá Nhập DAP (USD):" label-for="dap_price">
        <b-form-input id="dap_price" v-model="form.dap_price" type="text" v-on:input="tinh_tong_gia_ton_kho" required></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-13" label="Tổng giá tồn kho (USD):" label-for="tong_gia_ton_kho">
        <b-form-input id="tong_gia_ton_kho" v-model="form.tong_gia_ton_kho" type="text" readonly required></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-14" label="remark:" label-for="remark">
        <b-form-textarea id="remark" v-model="form.remark" rows="3"></b-form-textarea>
      </b-form-group>
      <br>
      <div style="float: right">
        <b-button type="submit" variant="light">{{ isEditingExisting ? 'Cập nhật' : action }} </b-button>
        <b-button type="reset" variant="light">Reset </b-button>
        <b-button @click="onClose" variant="light">Đóng</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  props: ['form_data', 'action'],
  data() {
    return {
      form: {
        ton_kho_hien_tai: 0,
        ton_kho_khac: 0,
        tong_ton_kho: 0,
        ton_cuoi_kho_chinh: 0,
        so_luong_nhap: 0,
        so_luong_xuat: 0,
        dap_price: 0,
        tong_gia_ton_kho: 0,
        remark: "",
        ...this.$props['form_data']
      },
      show: true,
      ton_kho_hien_tai_temp: this.$props['form_data'].ton_kho_hien_tai ? Number(this.$props['form_data'].ton_kho_hien_tai) : 0,
      isEditingExisting: this.$props['form_data'].id ? true : false,
      existingTonKho: this.$props['form_data'].ton_kho_hien_tai || 0,
      originalRemark: this.$props['form_data'].remark || "",
      isLoaded: false
    };
  },
  computed: {
    isNotMatch() {
      const tong = Number(this.form.tong_ton_kho) || 0;
      const khoChinh = Number(this.form.ton_cuoi_kho_chinh) || 0;
      return tong !== khoChinh;
    }
  },
  methods: {
    async pn_10_listener() {
      if (!this.form.pn_10) { this.isEditingExisting = false; return; }
      this.isLoaded = false;
      const params = { pn_10: this.form.pn_10 };
      const base_url = process.env.VUE_APP_API_ENDPOINT;

      try {
        const [resTuan, resPo, resTlt, resXnt, resPrice] = await Promise.all([
          axios.get(`${base_url}/api/v1/warehouses`, { params: { pn_10: this.form.pn_10, name: "kho_tuan" } }),
          axios.get(`${base_url}/api/v1/purchasing-orders`, { params }),
          axios.get(`${base_url}/api/v1/warehouses`, { params: { pn_10: this.form.pn_10, name: "kho_tlt" } }),
          axios.get(`${base_url}/api/v1/xuat-nhap-ton`, { params }),
          axios.get(`${base_url}/api/v1/nhap-kho`, { params })
        ]);

        if (resTuan.data.length > 0) {
          const rec = resTuan.data[0];
          this.isEditingExisting = true;
          this.existingTonKho = rec.ton_kho_hien_tai;
          this.form = Object.assign({}, this.form, rec);
          this.ton_kho_hien_tai_temp = Number(rec.ton_kho_hien_tai);
          this.originalRemark = rec.remark || "";
        } else {
          this.isEditingExisting = false;
          this.$delete(this.form, 'id');
          this.originalRemark = "";
        }

        if (resPo.data.length > 0) {
          this.$set(this.form, 'stamping', resPo.data[0].stamping);
          this.$set(this.form, 'english_des', resPo.data[0].english_des);
          this.$set(this.form, 'import_des', resPo.data[0].import_des);
        }
        
        this.$set(this.form, 'ton_kho_khac', resTlt.data.length > 0 ? Number(resTlt.data[0].ton_kho_hien_tai) : 0);
        this.$set(this.form, 'ton_cuoi_kho_chinh', resXnt.data.length > 0 ? Number(resXnt.data[0].ton_cuoi) : 0);
        this.$set(this.form, 'dap_price', resPrice.data.length > 0 ? resPrice.data[0].dap_price : 0);

        this.tinh_tong_ton_kho();
        this.tinh_tong_gia_ton_kho();
        this.isLoaded = true;
      } catch (error) { console.error(error); }
    },
    update_ton_kho_hien_tai() {
      const ton_dau = Number(this.ton_kho_hien_tai_temp) || 0;
      const nhap = Number(this.form.so_luong_nhap) || 0;
      const xuat = Number(this.form.so_luong_xuat) || 0;
      const result = ton_dau + nhap - xuat;
      
      this.$set(this.form, 'ton_kho_hien_tai', result);
      this.tinh_tong_ton_kho();
      this.tinh_tong_gia_ton_kho();

      const now = moment().format("DD/MM/YYYY HH:mm");
      const logEntry = `[${now}] Nhập: ${nhap}, Xuất: ${xuat}, Tồn: ${result}`;
      this.$set(this.form, 'remark', (this.originalRemark ? this.originalRemark + "\n" : "") + logEntry);
    },
    tinh_tong_ton_kho() {
      this.$set(this.form, 'tong_ton_kho', (Number(this.form.ton_kho_hien_tai) || 0) + (Number(this.form.ton_kho_khac) || 0));
    },
    tinh_tong_gia_ton_kho() {
      this.$set(this.form, 'tong_gia_ton_kho', ((Number(this.form.ton_kho_hien_tai) || 0) * (Number(this.form.dap_price) || 0)).toFixed(2));
    },
    onSubmit(event) {
      event.preventDefault();
      
      this.form.so_luong_nhap = Number(this.form.so_luong_nhap) || 0;
      this.form.so_luong_xuat = Number(this.form.so_luong_xuat) || 0;
      this.form.ton_kho_hien_tai = Number(this.form.ton_kho_hien_tai) || 0;
      this.form.ton_kho_khac = Number(this.form.ton_kho_khac) || 0;
      this.form.tong_ton_kho = Number(this.form.tong_ton_kho) || 0;
      this.form.ton_cuoi_kho_chinh = Number(this.form.ton_cuoi_kho_chinh) || 0;
      this.form.dap_price = Number(this.form.dap_price) || 0;
      this.form.tong_gia_ton_kho = Number(this.form.tong_gia_ton_kho) || 0;

      this.$set(this.form, 'name', 'kho_tuan');
      let url = process.env.VUE_APP_API_ENDPOINT + "/api/v1/warehouses";
      if (this.form.id) url += "/" + this.form.id;
      
      axios({
        method: this.form.id ? 'put' : 'post',
        url: url,
        data: this.form
      }).then(() => {
        this.$root.$emit('bv::hide::modal', 'modal-khotuan-form');
        this.$emit('refresh_table_data');
      }).catch(error => alert("Lỗi API: " + error));
    },
    onReset(event) {
      event.preventDefault();
      this.isLoaded = false;
      this.form = { ton_kho_hien_tai: 0, ton_kho_khac: 0, tong_ton_kho: 0 };
      this.show = false;
      this.$nextTick(() => { this.show = true; });
    },
    onClose() {
      this.$root.$emit('bv::hide::modal', 'modal-khotuan-form');
      this.$emit('refresh_table_data');
    }
  },
  mounted() {
    if (this.form.pn_10) { this.pn_10_listener(); }
  }
};
</script>

<style scoped>
button { padding: 5px; }
.small { font-size: 0.85em; margin-left: 5px; }
.text-danger { color: #dc3545 !important; }
.font-weight-bold { font-weight: 700; }
.ml-2 { margin-left: 0.5rem; }
</style>